import { FormGroup } from '@angular/forms';
import { RefundItemsFormDataBuilderInterface } from './form-data.builder.interface';

export interface RefundItemsFormBuilderInterface {
  getForm(data: RefundItemsFormDataBuilderInterface): FormGroup;
}
